import { z } from 'zod';
import { EntityIdSchema, PaginatedResponseSchema } from './common';

/**
 * Permiso granular (recurso.accion).
 */
export const PermisoSchema = z.object({
  id: EntityIdSchema,
  codigo: z.string().regex(/^[a-z_]+\.[a-z_]+$/, 'Formato recurso.accion esperado'),
  recurso: z.string(),
  accion: z.string(),
  descripcion: z.string().nullable().optional(),
});
export type Permiso = z.infer<typeof PermisoSchema>;

/**
 * Grupo de permisos (RBAC).
 */
export const GrupoSchema = z.object({
  id: EntityIdSchema,
  codigo: z.string(),
  nombre: z.string(),
  descripcion: z.string().nullable().optional(),
  es_sistema: z.union([z.literal(0), z.literal(1)]).or(z.boolean()),
  permisos: z.array(z.string()).optional(),
});
export type Grupo = z.infer<typeof GrupoSchema>;

/**
 * Input para PATCH /api/v1/grupos/:id/permisos.
 */
export const GrupoAsignarPermisosInputSchema = z.object({
  permisos: z.array(z.string().min(1)),
});
export type GrupoAsignarPermisosInput = z.infer<typeof GrupoAsignarPermisosInputSchema>;

/**
 * Response de GET /api/v1/permisos.
 */
export const PermisoListResponseSchema = PaginatedResponseSchema(PermisoSchema);
export type PermisoListResponse = z.infer<typeof PermisoListResponseSchema>;

/**
 * Response de GET /api/v1/grupos.
 */
export const GrupoListResponseSchema = PaginatedResponseSchema(GrupoSchema);
export type GrupoListResponse = z.infer<typeof GrupoListResponseSchema>;